<div class="beta-bar d-flex align-items-center" *ngIf="isBeta()">
  <div class="filler"></div>
  <div class="text-center mx-3">
    <span translate class="me-1">You are using a beta version of the website, please report issues to</span>
    <a href="mailto:app@ikointl.com">app&#64;ikointl.com</a>
  </div>
  <div class="filler"></div>
</div>
